import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showTokenExpiredAlert, getConfig, authHeader, getCustId, isApiSuccess } from "utils";

// GET subscriber/getBasicCustomerDetails/{custId}
export const customerDetails = createAsyncThunk('dashboard/customerDetails', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `subscriber/getBasicCustomerDetails/${getCustId()}`,
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

// GET subscriber/getUsedQuota/{custId} -> data: { usedQuota: "31.668 TB", totalQuota: "-0.001 GB" }
export const usedQuota = createAsyncThunk('dashboard/usedQuota', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `subscriber/getUsedQuota/${getCustId()}`,
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

const dashboard = createSlice({
    name: 'dashboard',
    initialState: {
        details: null,
        quota: null,
        loading: false,
        quotaLoading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(customerDetails.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(customerDetails.fulfilled, (state, action) => {
            state.loading = false;
            if (isApiSuccess(action?.payload)) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else {
                state.details = null
            }
        });
        builder.addCase(customerDetails.rejected, (state) => {
            state.loading = false;
        });

        builder.addCase(usedQuota.pending, (state) => {
            state.quotaLoading = true;
        });
        builder.addCase(usedQuota.fulfilled, (state, action) => {
            state.quotaLoading = false;
            if (isApiSuccess(action?.payload)) {
                state.quota = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            }
        });
        builder.addCase(usedQuota.rejected, (state) => {
            state.quotaLoading = false;
        });
    }
})

export default dashboard.reducer;
